import React, { Component } from 'react';

// Custom Components
import Header from '../components/Header'
import ProjectCard from '../components/ProjectCard'

// Images 
import * as graph from '../img/graph.json'
import * as bank from '../img/bank.json'
import * as book from '../img/book.json'
import * as binary from '../img/binary.json'
import * as dither from '../img/dither.json'
import * as redBlack from '../img/redBlack.json'
import * as noise from '../img/noise-reduction.json'
  
class Projects extends Component {
   constructor(props) {
    super(props);
    this.state = {
    }
  }
  render() {
    return (
    <div 
    >
        <Header
            title="Missouri State"
            backgroundColor={'#FFF'}
            textColor={'maroon'}
            jobTitle={'Computer Science Student'}
            yearsAtRole={"2017-2021"}
        /> 
        <div 
            className="center"
            style={{
                paddingLeft: '5%'
            }}
        >
            <ProjectCard
                title={"Finding Number of Connected Components in Graph"}
                animation={graph}
                loop={true}
                github={"https://github.com/DaltonWemer/connected-components"}
                description={"This program uses disjoint set operations to determine the number of connected components in a graph that is represented by an adjacency matrix (n x n). The program also shows all nodes that are present in each of the connected components. A connected component in a directed graph G = (E, V) is a subgraph in which two verticies are connected to each other by paths but are connected to no other vertices in the graph."}
            />
            <ProjectCard
                title={"Implementation of Red and Black Tree"}
                animation={redBlack}
                loop={false}
                github={"https://github.com/DaltonWemer/red-black-tree"}
                description={"A red–black tree is a self-balancing binary search tree. Each node of the binary tree has an extra bit, and that bit is often interpreted as the color (red or black) of the node. These color bits are used to ensure the tree remains approximately balanced during insertions and deletions. Most operations on a Red Black Tree can be completed in O(log n)."}
            />
            <ProjectCard
                title={"Bankers Algorithm Simulation"}
                github={"https://github.com/DaltonWemer/bankers-algorithm"}
                animation={bank}
                loop={false}
                description={"The banker's algorithm is designed for both resource allocation and deadlock avoidance. It tests the safety of a system by simulating the system's state if the requested resources were allocated to a process. If the system is capable of fulfilling the request safely, the proper resources will be allocated. If not, the request will be denied. This process is similar to the process a bank would go through if they were looking to evaluate the approval of a loan, a bank would not allocate its money in a way that would prevent them from taking care of the rest of its customers. My program is a simulation of this core algorithm in any operating system."}
            />
             <ProjectCard
                title={"Page Replacement Algorithms"}
                github={"https://github.com/DaltonWemer/page-replacement-algorithm"}
                description={"This program is a simulation of a few of the most popular page replacement algorithms: FIFO (First In, First Out), LRU (Least Recently Used), Random and, Optimal. These are all different approaches to solve the same problem and measuring how each of thsese might perform in a real world example in operating systems is what this program aims to do. An operating system uses paging for memory managment. Page replacement algorithm determines when a page needs to be repalced with a new page coming in.  "}
                animation={book}
            />
            <ProjectCard
                title={"Noise Reduction on Images"}
                loop={true}
                github={"https://github.com/DaltonWemer/noise-reduction-processing"}
                description={"This program uses processing to reduce noise from images. This program is hardcoded to clean up the image using an reigon size of 3. It uses neighborhood processing to loop through a 3 x 3 matrix around every pixel and average out the color of each of the pixels. This program does not use a dynamic matrix but does have pretty decent results at removing static from images"}
                animation={noise}
            />
            <ProjectCard
                title={"Floyd-Steinberg Algorithm"}
                loop={true}
                github={'https://github.com/DaltonWemer/floyd-steinberg-processing'}
                description={"The Floyd-Steinberg Algorithm is an image dithering algorithm that is commonly used when compressing images such as GIFs as GIFs have a restricted color pallete. It can be used to lower the size of images by compressing the range of colors. This program simulates indexed color. It loads a color palette calculated using the k-means algorithm. These colors are substituted for the original pixel colors in the image."}
                animation={dither}
            />
            <ProjectCard
                title={"Binary Addition Calculator"}
                loop={true}
                github={'https://github.com/DaltonWemer/binary-addition'}
                description={"Simple C++ program that takes two binary numbers of n characters length and returns the sum. It has validation, so if a user inputs any data that is not a binary number, the program will return an error."}
                animation={binary}
            />
        </div>
    </div>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/screens/Projects.js